export class RejectMigrationRequest {
  reason: string;

  constructor(reason: string) {
    this.reason = reason;
  }
}
export class OverallMetrics {
  totalRecords: number = 0;
  succeeded: number = 0;
  failed: number = 0;
  constructor(
    totalRecords: number = 0,
    succeeded: number = 0,
    failed: number = 0
  ) {
    this.totalRecords = totalRecords;
    this.succeeded = succeeded;
    this.failed = failed;
  }
}
export class MigrationStatusColorMap {
  statusColor: string = "";
  statusIcon: string = "";
  color: string = "";
  constructor(
    statusColor: string = "",
    statusIcon: string = "",
    color: string = ""
  ) {
    this.statusColor = statusColor;
    this.statusIcon = statusIcon;
    this.color = color;
  }
}
